import { useMutation } from "react-query";
import { getAmendRiskProposal } from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

export function useAmendRiskProposal() {
  return useMutation(
    ({ fleetId, vehicleId }: { fleetId: number; vehicleId: number }) =>
      getAmendRiskProposal(fleetId, vehicleId),
    {
      mutationKey: MUTATION_KEYS.amendRiskProposal,
      onError: (err) => {
        handleAxiosError(err);
      },
    },
  );
}
